/* eslint-disable max-len */
import React,{useContext,useState,useEffect} from 'react'
import BannerImage from '../../../components/BannerImage'
import SignIn from './Components/SignIn'
import GlobalContext from '../../../components/Context/GloablContext';
import { useDispatch } from 'react-redux';
import { logIn } from '../authSlice';
import OtpPage from './Components/Otp';
import { handleClear, handleSidebarAnimation } from '../../../redux/commonSlice';
import { useNavigate } from 'react-router-dom';
import ForgotPassword from './Components/ForgotPassword';
import SetPreferencesModal from './Components/SetPreferencesModal';
import { userService } from '../../../services/user.services';
import { handleRestrictKey } from '../../../redux/systemConfigSlice';
import refreshIdToken from '../../../CommonMethods/RefreshIdFunction';
import MaskedEmail from '../../../CommonMethods/MaskedEmail';
import MaskedEmailJS from '../../../CommonMethods/MaskedEmailJS'
import TrustBrowser from './Components/TrustBrowser';
import authenticateUser from '../../../config/aws-export';
import DuplicateTabCloseModal from './Components/DuplicateTabCloseModal';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import { fetchImageAsBlob, getPDFImage, storePDFImage } from '../../../components/HelpGuideModal/indexdb';
import { persistAuthSession, broadcastLogin } from '../../../CommonMethods/authSession';
import { getClientIP, storeIPAddress } from '../../../services/ipAddress.service';
  
export default function LoginPage() {
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage,setIsSideBareditSocket,setEditSocket,WebSocketConnection,handleOnClickClearSearch , fetchAndCacheHelpGuides } = useContext(GlobalContext)
    const [IsLoginPage, setIsLoginPage] = useState(true);
    const [loading, setloading] = useState(false);
    const [userData, setuserData] = useState({});
    const [idToken,setIdToken]=useState("")
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [otp, setOtp] = useState("000000");
  
    const [duration,setDuration]=useState('')
    

    const [displayOtpScreen,setDisplayOtpScreen]=useState(false)
    const dispactch = useDispatch()
    const [loginCredentials, setloginCredentials] = useState({
        email: '',
        password: ''
    });

 

    const [error, seterror] = useState(false);
    const [emptyError,setEmptyError]=useState(false)
    const navigate=useNavigate()

    const [preferenceModel, setPreferenceModel] = useState(false);
    const [preferenceList, setPreferenceList] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [preferenceLoading, setPreferenceLoading] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState([]);
    const [isTrustMyBrowser,setIsTrustMyBrowser] = useState(false)
    const [duplicateTabModal, setDuplicateTabModal] = useState(false);
    const [dupLoadingBtn,setDupLoadingBtn]=useState(false);
    const [loginData,setLoginData] = useState('')
    
    const [isSubmitSelected,setIsSubmitSelected] = useState(false)
    const [loginError, setloginError] = useState('')
    const { email, password } = loginCredentials

    GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

    const handleLoginCredentilas = (key, value) => {
        if(key==="email"){
            setloginCredentials((current) => ({
                ...current,
                [key]: value.replace(/\s/g, '')
            }))

        }else{
            setloginCredentials((current) => ({
                ...current,
                [key]: value
            }))

        }
        
    }
    
    const handleRefreshToken = async () => {
        if(sessionStorage.getItem('IdToken')){
            refreshIdToken()
        }
        
    };

    const handleLogin = async (e, key) => {
        handleOnClickClearSearch()
        setIsSubmitSelected(true)
        seterror(false)
        e.preventDefault();
        if (key === undefined) {
            setloading(true);
            setOtp(Array(6).fill(""))

        }
     
        if(email?.trim().replace(/\s/g, '')===""|| password?.trim()===""){
            setEmptyError(true)
            setToastErrorMessage("Please fill in all the mandatory fields")
            setloading(false)
            return
        }
        sessionStorage.setItem('email', email);
        const browser_id = localStorage.getItem('arcm_trust_browser_token') ? localStorage.getItem('arcm_trust_browser_token') : ''
        try {
            const loginresponse = await userService.login(email.toLowerCase().trim().replace(/\s/g, ''), password,browser_id);
            setLoginData(loginresponse);
            const myInfo = {
                first_name: loginresponse?.data?.first_name,
                middle_name: loginresponse?.data?.last_name,
            }
            persistAuthSession({
                'user-info': JSON.stringify(myInfo),
            });
            
            if((loginresponse?.data?.isLoggedIn && loginresponse?.data?.isLoggedIn===true) || (loginresponse?.data?.isLoggedIn && loginresponse?.data?.isLoggedIn===true) ){

                persistAuthSession({
                    email,
                    IdToken: loginresponse?.data?.IdToken,
                    currentTimestamp: ((new Date).getTime().toString()),
                    RefreshToken: loginresponse?.data?.RefreshToken,
                    AccessToken: loginresponse?.data?.AccessToken,
                    user_id: loginresponse?.data?.user_id,
                    id: loginresponse?.data?.id,
                    user_type: loginresponse?.data?.user_type,
                    session_token: loginresponse.data.session_token,
                });
                setPreferenceList(loginresponse.data.Preference_list)

                if(loginresponse?.data?.restrict!==undefined){
                    dispactch(handleRestrictKey(loginresponse?.data?.restrict))
                    setIsSideBar(loginresponse?.data?.restrict)
                }

                setloading(false)
                setDuplicateTabModal(true)
                
                return 
            }
            
            if(duplicateTabModal===false && loginresponse?.data?.Preference_list && loginresponse.data?.Preference_list?.length > 0) {

                setPreferenceModel(true)
                persistAuthSession({
                    session_token: loginresponse.data.session_token,
                    user_type: loginresponse?.data?.user_type,
                });
                setPreferenceList(loginresponse.data.Preference_list)
                setloading(false);
                return
            } else{
                if (loginresponse.error) {
                    seterror(true);
                    setloginError(loginresponse.message.response.data.message)
                    setloading(false);
                } else {
                
                    persistAuthSession({
                        email,
                        IdToken: loginresponse?.data?.IdToken,
                        currentTimestamp: ((new Date).getTime().toString()),
                        RefreshToken: loginresponse?.data?.RefreshToken,
                        AccessToken: loginresponse?.data?.AccessToken,
                        user_id: loginresponse?.data?.user_id,
                        id: loginresponse?.data?.id,
                        user_type: loginresponse?.data?.user_type,
                        session_token: loginresponse.data.session_token,
                    });
                   

                    if ((loginresponse?.data?.restrict === false && loginresponse?.data?.trust_my_browser === true) || loginresponse?.data?.restrict === false) {     
                   
                        dispactch(logIn());
                        broadcastLogin();
                        // Capture and store IP address
                        getClientIP().then(ip => {
                            if (ip) {
                                storeIPAddress(ip);
                            }
                        });
                        refreshIdToken()
                        WebSocketConnection()

                        authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''), password)                        
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        setIsSideBar(false)
                        setToastmessage('Login successful')
                        
                        setTimeout(function() {
                            // dispactch(handleSidebarAnimation(false))
                            loginresponse?.data?.user_type==='super-admin'?navigate('/system-configuration'):navigate('/profile')
                        }, 500);
                        
                        return
                    }
                    if(loginresponse?.data?.restrict === "true" || loginresponse?.data?.restrict === true) {

                        // sessionStorage.setItem('restrict', loginresponse?.data?.restrict)
                        //sessionStorage.setItem('user_type', loginresponse?.data?.user_type);
                        dispactch(logIn());
                        broadcastLogin();
                        // Capture and store IP address
                        getClientIP().then(ip => {
                            if (ip) {
                                storeIPAddress(ip);
                            }
                        });
                        dispactch(handleRestrictKey(loginresponse?.data?.restrict))
                        setIsSideBar(loginresponse?.data?.restrict)
                        WebSocketConnection()
                        setToastmessage('Login successful')

                        refreshIdToken()
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        navigate('/profile')
                        return
                    }
                    if(loginresponse.data.is_reset_password === false || loginresponse.data.status === "reset") { 
                        
                        persistAuthSession({
                            'custom:is_first_time_login': "true",
                        });
                        //sessionStorage.setItem('user_type', loginresponse?.data?.user_access_type);
                        setToastmessage('Login successful')

                        refreshIdToken()
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        navigate('/reset-password',{state:{'refresh_interval':intervalId}})
                        return
                    }
                    if(loginresponse?.data?.status==='success'){
                        dispactch(logIn());
                        broadcastLogin();
                        refreshIdToken()
                        // Capture and store IP address
                        getClientIP().then(ip => {
                            if (ip) {
                                storeIPAddress(ip);
                            }
                        });
                        WebSocketConnection()

                        authenticateUser(email.toLowerCase().trim().replace(/\s/g, ''), password)                        
                        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
                        setIsSideBar(false)
                        setToastmessage('Login successful')
                        
                        setTimeout(function() {
                            // dispactch(handleSidebarAnimation(false))
                            loginresponse?.data?.user_type==='super-admin'?navigate('/system-configuration'):navigate('/profile')
                        }, 500);
                        
                        return 
                    }
                    // setToastmessage('You’ve received an OTP to your registered email address or +91 xxxx-xxxxx')
                    setIsLoginPage(false);
                    setDisplayOtpScreen(true);
                    setloading(false);
                }
            }


   
            
        } catch (error) {
            if(error.code==="NotAuthorizedException"){
                setloginError(error.message)
            }
            else{
                setloginError(error.message?.split("error")[1])
            }
            
            seterror(true);
            setloading(false);

        }

    };
    const handelClear = () => {
        setloginCredentials({
            email: '',
            password: ''
        });
        setloginError('')
        seterror(false)
    }
    

    const handleSelectPreference = async (item) => {
        setSelectedPreference(item)
    }
    const otpMessage = selectedPreference.otp_preference_mode === "email" ? selectedPreference.preference // Mask it before setting if necessary
        : `${selectedPreference?.country_code} ${
            selectedPreference?.preference?.slice(0, 2) +
        "*".repeat(selectedPreference?.preference?.length - 4) +
        selectedPreference?.preference?.slice(-2)
        }`;


    const handleSendotptoPreference = async () => {
        setPreferenceLoading(true)
        const response = await userService.sendOtptoPreference(selectedPreference._id);
        if(response.error === false) {
            sessionStorage.setItem('verify_otp_session_token', response.data.verify_otp_session_token);
            setDuration(response.data.otp_resend_duration);
            sessionStorage.setItem('preference_id', selectedPreference._id);
            setToastmessage(`You’ve been sent an OTP to ${otpMessage}`)
            setDisplayOtpScreen(true)
            setIsLoginPage(false)
            setPreferenceLoading(false)
            setPreferenceModel(false)
        } else{
            setPreferenceLoading(false)
            setToastErrorMessage(response.message)
            // setDisplayOtpScreen(true)
            // setPreferenceModel(false)
        }
    }

    const handleClose = () => {
        setPreferenceModel(false)
        setIsDropdownOpen(false)
        setSelectedPreference([])
    }

    // Duplicate tab closing fun below

    const handleAllowDuplicateTabClose = async() => {    
                 
        if(loginData?.data?.Preference_list===undefined && loginData?.data?.isLoggedIn===true){
            setDupLoadingBtn(true)
            
            persistAuthSession({
                email,
                IdToken: loginData?.data?.IdToken,
                currentTimestamp: ((new Date).getTime().toString()),
                RefreshToken: loginData?.data?.RefreshToken,
                AccessToken: loginData?.data?.AccessToken,
                user_id: loginData?.data?.user_id,
                id: loginData?.data?.id,
                user_type: loginData?.data?.user_type,
            });

            await userService.DuplicateTabClose('');
            broadcastLogin();
            setDuplicateTabModal(false);
            // Capture and store IP address
            getClientIP().then(ip => {
                if (ip) {
                    storeIPAddress(ip);
                }
            });
            refreshIdToken()
            const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);

            if (loginData.data?.user_type === 'super-admin') {
                window.location.href = '/system-configuration';
            } else {
                window.location.href = '/profile';
            }

            WebSocketConnection()


        }
        else{
            setDuplicateTabModal(false)
            setPreferenceModel(true) 
        }
    }

    const handleDuplicateModalClose = async() => {
        setPreferenceModel(false)
        setDuplicateTabModal(false)
        const DuplicateTabCancelRes  = await userService.CancelDuplicatelogin('')
    }

    
    
    return (
        <> 
            <div className='flex bg-white'>
                {!isTrustMyBrowser&&<BannerImage />}
                {!isForgotPassword  && IsLoginPage && !displayOtpScreen&& !isTrustMyBrowser && <SignIn
                    isSubmitSelected={isSubmitSelected}
                    setIsSubmitSelected={setIsSubmitSelected}
                    setIsLoginPage={setIsLoginPage}
                    email={email}
                    emptyError={emptyError}
                    setEmptyError={setEmptyError}
                    handleLoginCredentilas={handleLoginCredentilas}
                    error={error}
                    loginError={loginError}
                    seterror={seterror}
                    password={password}
                    loading={loading}
                    setIsForgotPassword={setIsForgotPassword}
                    handleLogin={handleLogin} 
                />}
                {duplicateTabModal &&
                    <DuplicateTabCloseModal
                        tittle={'Duplicate Session?'}
                        buttonName={'Yes'}
                        message={'You are already logged in through another system. Do you want to end the other session and login here?'}
                        handleAllowDuplicateClose={handleAllowDuplicateTabClose}
                        handleClose={handleDuplicateModalClose}
                        dupLoadingBtn={dupLoadingBtn}
                        data_testid={"continue-btn"}
                    />
                }
                {/* {!isForgotPassword  && IsLoginPage && !displayOtpScreen&& <ResetPassword
                />} */}
                {/* {!isForgotPassword  && !IsLoginPage &&userData.signInUserSession===null&& <p><OtpPage/></p>} */}
                {displayOtpScreen&&<OtpPage 
                    selectedPreference={selectedPreference}
                    setSelectedPreference={setSelectedPreference}
                    setloginCredentials={setloginCredentials}
                    setIsLoginPage={setIsLoginPage}
                    handleLogin={handleLogin}
                    duration={duration}
                    setIsTrustMyBrowser={setIsTrustMyBrowser}
                    userData={userData}
                    setOtp={setOtp}
                    otp={otp}
                    setIsForgotPassword={setIsForgotPassword}
                    displayOtpScreen={displayOtpScreen}
                    handelClear={handleClear}
                    setPreferenceModel={setPreferenceModel}
                    setDisplayOtpScreen={setDisplayOtpScreen}
                    loginCredentials={loginCredentials}
                    loginData={loginData}
                />
                    
                }
                {/* {!isForgotPassword&&!IsLoginPage&& idToken!=="" && <SideBar/>} */}
                {isForgotPassword  && IsLoginPage &&
                    <ForgotPassword
                        setIsForgotPassword={setIsForgotPassword}
                        handelClear={handelClear}
                        email={email}
                        emptyError={emptyError}
                        setEmptyError={setEmptyError}
                        error={error}
                        loginError={loginError}
                        seterror={seterror}
                        loading={loading}
                        setloading={setloading}
                    />}

                {preferenceModel && !duplicateTabModal &&
                <SetPreferencesModal
                    tittle={'Verify your Identity'}
                    buttonName={'Send'}
                    message={'Select your preference to receive the verification code'}
                    preferenceList={preferenceList}
                    isDropdownOpen={isDropdownOpen}
                    setIsDropdownOpen={setIsDropdownOpen}
                    handleSelectPreference={handleSelectPreference}
                    handleSendotptoPreference={handleSendotptoPreference}
                    selectedPreference={selectedPreference}
                    handleClose={handleClose}
                    setPreferenceLoading={setPreferenceLoading}
                    preferenceLoading={preferenceLoading}
                />
                }
                {
                    isTrustMyBrowser && 
                    <TrustBrowser 
                        setIsTrustMyBrowser={setIsTrustMyBrowser}/>
                }

            </div>
        </>
    )
}
